
import { Section } from "./data-types";

export const MembersResources: {
	sections: (Section | (() => JSX.Element))[];
} = {
	sections: [
		{
			type: "cards",
			options: {
				columns: 2,
			},
			items: [
				{
					type: "CardItem",
					options: {
						span: "max"
					},
					data: {
						title: "Geography in Irish Higher Education",
						content: () => [
							<p>There are 8 universities in Ireland that offer undergraduate and postgraduate geography degrees. Click below to reach the relevant Dept/School.</p>,
							<div class="resources-grid">
								<div class="resources-item"><a href="http://www.ucd.ie/gpep/"><img src="/images/resources/ucd.jpg" alt="Picture" /></a></div>
								<div class="resources-item"><a href="http://www.nuigalway.ie/geography/"><img src="/images/resources/nuigalway.png" alt="Picture" /></a></div>
								<div class="resources-item"><a href="https://www.mic.ul.ie/faculty-of-arts/department/geography?index=0"><img src="/images/resources/mic_ul.jpg" alt="Picture" /></a></div>
								<div class="resources-item"><a href="https://www.dcu.ie/historygeography"><img src="/images/resources/dcu.png" alt="Picture" /></a></div>
								<div class="resources-item"><a href="https://www.qub.ac.uk/schools/NBE/Disciplines/Geography/"><img src="/images/resources/qub.png" alt="Picture" /></a></div>
								<div class="resources-item"><a href="http://www.tcd.ie/Geography/"><img src="/images/resources/tcd.png" alt="Picture" /></a></div>
								<div class="resources-item"><a href="http://geography.nuim.ie/"><img src="/images/resources/geography_nuim.jpg" alt="Picture" /></a></div>
								<div class="resources-item"><a href="http://www.ucc.ie/en/geography/"><img src="/images/resources/ucc.gif" alt="Picture" /></a></div>
							</div>
						]
					},
				},
				{
					type: "CardItem",
					options: {
						// span: "max"
					},
					data: {
						title: "Related organisations",
						content: () => [
							<p>
								<ul>
									<li><a href="http://igu-online.org/">International Geographical Union / Union Geographique Internationale</a></li>
									<li><a href="http://www.eugeo.eu/">European Association of Geographers</a></li>
									<li><a href="http://www.ucd.ie/inlt/">International Network for Learning and Teaching in Geography (INLT)</a></li>
									<li><a href="http://agti.ie/">Assoc. of Geography Teachers of Ireland</a></li>
									<li><a href="http://www.tcd.ie/Geography/IQUA/Index.htm">Irish Quaternary Association</a></li>
									<li><a href="http://www.gsi.ie/">Geological Survey of Ireland</a></li>
									<li><a href="http://www.osi.ie/">Ordnance Survey Ireland</a></li>
								</ul>
							</p>
						]
					},
				},
				{
					type: "CardItem",
					options: {
						// span: "max"
					},
					data: {
						title: "Associated research centres/projects",
						content: () => [
							<p>
								<ul>
									<li><a href="http://earth.ucd.ie/">UCD Earth Institute</a></li>
									<li><a href="http://www.nuim.ie/nirsa/">National Institute for Regional and Spatial Analysis</a></li>
									<li><a href="http://geary.ucd.ie/">Geary Institute</a></li>
									<li><a href="http://www.qub.ac.uk/c-star/">C-STAR: Centre for Spatial Territorial Analysis and Research</a></li>
									<li><a href="http://icarus.nuim.ie/">Irish Climate Analysis and Research Unit</a></li>
									<li><a href="http://www.nuigalway.ie/eci/">Environmental Change Institute</a></li>
									<li><a href="http://cmrc.ucc.ie/">Coastal and Marine Resources Centre</a></li>
									<li><a href="http://www.science.ulster.ac.uk/ccmr/">Centre for Coastal and Marine Research</a></li>
									<li><a href="http://ncg.nuim.ie/">National Centre for Geocomputation</a></li>
									<li><a href="https://www.geographicalsocietyireland.ie/www.consensus.ie">Consensus Project</a></li>
								</ul>
							</p>
						]
					},
				},
				{
					type: "CardItem",
					options: {
						span: "max"
					},
					data: {
						title: "Bibliography of Irish Geography 2008-2011",
						content: () => [
							<p>
								<p><a href="https://www.geographicalsocietyireland.ie/uploads/1/9/0/2/19022599/bibliography-2008-11.pdf" title="Download file: bibliography-2008-11.pdf"><img src="/images/resources/pdf.png" alt="" /></a></p>
								<p><strong>bibliography-2008-11.pdf</strong></p>
								<p><a href="https://www.geographicalsocietyireland.ie/uploads/1/9/0/2/19022599/bibliography-2008-11.pdf" title="Download file: bibliography-2008-11.pdf">Download File</a></p>
								<p>A bibliography of books, articles, book chapters and reports published by geographers resident in Ireland and works on Irish topics by geographers resident elsewhere prepared for the Geographical Sciences Committee of the Royal Irish Academy as part of its Report to the 32nd International Geographical Congress, Cologne.</p>
							</p>
						]
					},
				}
			]
		}
	]
}
